class FacebookSettingsController {
  constructor($state) {
    'ngInject';
    $state.go('settings.integrations');
  }
}

export default FacebookSettingsController;



// WEBPACK FOOTER //
// ./app/pages/settings/facebook.js